export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7734.1d8e5d8d.jpg";